"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 16 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * CurrencyConverter.
 *
 * @author RV
 */


var CurrencyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CurrencyConverter, _DataObjectConverter_);

  function CurrencyConverter() {
    _classCallCheck(this, CurrencyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CurrencyConverter).apply(this, arguments));
  }

  return CurrencyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CurrencyConverter = CurrencyConverter;